import { createSelector } from 'reselect';

import { getReportsClientColumns } from '../declarations/reportsClient/reportsClient';
import { ColumnsSettingsViewDict } from '../typings/common';
import { State } from '../typings/state';

export const selectReportsClientColumns = createSelector(
    (state: State) => state.reportClient.login,
    (state: State) => state.reportClient.columnsSettings,
    (login: string, columnsSettings: ColumnsSettingsViewDict) => {
        return getReportsClientColumns(columnsSettings, true, login);
    }
);
